export default __webpack_public_path__ + "static/media/javascript.5a908e0c.png";